var CurrentUser = require("lib/account/CurrentUser");
var Modal = require("components/utility/AltModal");
var LoadingButton = require("components/utility/LoadingButton");
var ErrorDisplay = require("components/utility/ErrorDisplay");

require('org/roster/parent_emails_modal.scss');

class ParentEmailsModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { students: {}, loading: false };
	}

	show() {
		this.refs.modal.show();
		this.fetchStudentList();
	}

	fetchStudentList() {
		var params = { embed: "student_list.students,student.parent,parent.email" };

		CurrentUser.api().getStudentList(this.props.activeStudentListID, params, $wr.apiHandler(function(response) {
			this.setState({ students: response.student_list.students });
		}.bind(this)));
	}

	submitParentEmail(e) {
		$wr.nope(e)
		this.refs.errors.reset();
		var errors = [];

		if (!this.state.loading) {
			this.setState({ loading: true });

			var addedStudentIDs = [];
			var addedParentEmails = [];
			var updatedParentIDs = [];
			var updatedParentEmails = [];
			var newStudents = [];

			this.state.students.map(function(student){
				var studentRef = "parentEmails" + student.id;
				var newStudent = _.clone(student);
				
				var emailRegEx = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))){2,6}$/i;

				if (this.refs[studentRef] && this.refs[studentRef].value != "") {
					var newParentEmail = this.refs[studentRef].value;
					if (!emailRegEx.test(newParentEmail)) {
						errors.push("Please make sure all email addresses are valid.");
						$(this.refs[studentRef]).addClass('errorRow');
					} else if (!student.has_parent) {
						var parentInfo = { email: newParentEmail, not_accepted_terms: true };
						newStudent.parent = parentInfo;
						newStudent.has_parent = true;

						addedStudentIDs.push(student.id);
						addedParentEmails.push(newParentEmail);
					} else if (student.has_parent && student.parent.email != newParentEmail) {
						newStudent.parent.email = newParentEmail;

						updatedParentIDs.push(student.parent.id);
						updatedParentEmails.push(newParentEmail);
					}
				}
				newStudents.push(newStudent);
			}.bind(this));

			var totalParentEmails = addedParentEmails.length + updatedParentEmails.length;
			if (errors.length == 0) {
				if (totalParentEmails > 0) {
					$(this.refs.parentEmailTable).find("input").removeClass('errorRow');

					var addressWord = $wr.pluralize("Address", totalParentEmails, "Addresses");
					var title = "Email " + addressWord + " Added!";

					if (totalParentEmails == 1) {
						var emailText = " The email has been ";
					} else {
						var emailText = " The emails have been ";
					}
					var text = "You have updated " + totalParentEmails + " parent email " +
						addressWord.toLowerCase() + "!" + emailText + "scheduled and will send shortly.";

					if (addedParentEmails.length > 0) {
						var parentData = { parents: { student_ids: addedStudentIDs, auth_emails: addedParentEmails } };
						CurrentUser.api().postParents(parentData, $wr.apiHandler(function(response) {
							// Do nothing
						}.bind(this)));
					}
					if (updatedParentEmails.length > 0) {
						this.updateParentEmails(updatedParentIDs, updatedParentEmails);
					}

					this.setState({ loading: false, students: newStudents });
					this.refs.modal.hide();
					window.wrNotifications.triggerDropDownNotification({
						title: title, text: text, icon: "ok-circle" });
				} else {
					this.setState({ loading: false });
					this.refs.modal.hide();
				}
			} else {
				this.setState({ loading: false });
				this.refs.errors.setErrors(errors);
			}
		}
	}

	updateParentEmails(ids, emails) {
		var parentData = { parent: { email: emails.pop() } };
		CurrentUser.api().patchParent(ids.pop(), parentData, $wr.apiHandler(function(response) {
			if (emails.length > 0) {
				this.updateParentEmails(ids, emails);
			}
		}.bind(this)));
	}

	render() {
		var headerRow = (
			<tr>
				<th className="studentName">Student</th>
				<th>Parent Email</th>
			</tr>
		)
		var students = _.sortBy(this.state.students, function(s){ return s.last_name });
		var studentRows = students.map(function(student) {
			if (student.parent != null) {
				var currentParentEmail = student.parent.email;
			} else {
				var placeholderValue = "Enter parent email";
			}
			var parentEmailSection = (
				<input className="form-control" placeholder={ placeholderValue }
					type="email" ref={ "parentEmails" + student.id } defaultValue={ currentParentEmail } />
			)
			return (
				<tr key={ student.id }>
					<td className="studentName">{ student.display_name }</td>
					<td>{ parentEmailSection }</td>
				</tr>	
			)
		}.bind(this))
		var modalBody = (
			<div className="parentEmailTable" ref="parentEmailTable">
				<p className="instructionsText">
					Add parent emails so that they can sign off on their students' reading logs 
					every week. We don't share email addresses and we only email parents to 
					request reading log approval and share their child's reading progress.
				</p>
				<form onSubmit={ this.submitParentEmail }>
					<ErrorDisplay ref="errors" />
					<table className="table">
						<tbody>
							{ headerRow }
							{ studentRows }
						</tbody>
					</table>
					<button className="btn buttonSuccess center-block" onClick={ this.submitParentEmail }>
						Save Emails
					</button>
				</form>	
			</div>
		);
		
		return (
			<Modal className="parentEmailsModal" ref="modal" headerText="Add & Edit Parent Emails">
				{ modalBody }
			</Modal>
		);
	}
}

ParentEmailsModal.propTypes = StrictPropTypes({
	activeStudentListID: PropTypes.number.isRequired
});

module.exports = ParentEmailsModal;


// WEBPACK FOOTER //
// ./modules/components/org/roster/ParentEmailsModal.js